import { AvatarWithDetails } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import React from 'react';

type PayDetailsTopProps = {
  vendorName?: string | null;
  subTitle?: string | null;
};

export const PayDetailsTopWidget: React.FC<PayDetailsTopProps> = ({ vendorName, subTitle }) => {
  const { formatMessage } = useMelioIntl();

  return (
    <AvatarWithDetails
      mainLabelProps={{ label: vendorName || formatMessage('widgets.payDetailsTop.missingVendorName') }}
      description={subTitle || ''}
      avatarProps={{ name: vendorName || '?' }}
    />
  );
};
